import { defineMessages } from "react-intl"

export const msrpMessages = defineMessages({
	optionPriceSum: {
		defaultMessage: "Thereof equipment",
		id: "msrp.optionPriceSum",
	},
	totalPrice: {
		defaultMessage: "Total",
		id: "msrp.totalPrice",
	},
})
